// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface SupportTagRecord
 */
export interface SupportTagRecord {
    /**
     * The id of the tag
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportTagRecord
     */
    id?: string;
    /**
     * The chargemaster id
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportTagRecord
     */
    chargemasterId?: string;
    /**
     * The claim id
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportTagRecord
     */
    claimId?: string;
    /**
     * The payment id
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportTagRecord
     */
    paymentId?: string;
    /**
     * The transmission id
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportTagRecord
     */
    transmissionId?: string;
    /**
     * The clearinghouse id
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportTagRecord
     */
    clearinghouseId?: string;
    /**
     * The provider id
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportTagRecord
     */
    providerId?: string;
    /**
     * The payer id
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportTagRecord
     */
    payerId?: string;
    /**
     * The subscriber id
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportTagRecord
     */
    subscriberId?: string;
    /**
     * The patient id
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportTagRecord
     */
    patientId?: string;
    /**
     * The facility id
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportTagRecord
     */
    facilityId?: string;
    /**
     * The professional id
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportTagRecord
     */
    professionalId?: string;
    /**
     * The institutional id
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportTagRecord
     */
    institutionalId?: string;
    /**
     * The dental id
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportTagRecord
     */
    dentalId?: string;
    /**
     * The NY NF3 id
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportTagRecord
     */
    nynf3Id?: string;
    /**
     * The professional template id
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportTagRecord
     */
    professionalTemplateId?: string;
    /**
     * The institutional template id
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportTagRecord
     */
    institutionalTemplateId?: string;
    /**
     * The dental template id
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportTagRecord
     */
    dentalTemplateId?: string;
    /**
     * The nynf3 template id
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportTagRecord
     */
    nynf3TemplateId?: string;
    /**
     * The document id
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportTagRecord
     */
    documentId?: string;
    /**
     * The mail id
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportTagRecord
     */
    mailId?: string;
    /**
     * The letter id
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportTagRecord
     */
    letterId?: string;
    /**
     * The fax send id
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportTagRecord
     */
    faxSendId?: string;
    /**
     * The fax receive id
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportTagRecord
     */
    faxReceiveId?: string;
    /**
     * The guarantor id
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportTagRecord
     */
    guarantorId?: string;
    /**
     * The fax receive id
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportTagRecord
     */
    messageId?: string;
    /**
     * The seller id
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportTagRecord
     */
    sellerId?: string;
    /**
     * The clearinghouse era id
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportTagRecord
     */
    clearinghouseEraId?: string;
    /**
     * The clearinghouse era item id
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportTagRecord
     */
    clearinghouseEraItemId?: string;
    /**
     * The coding id
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportTagRecord
     */
    codingId?: string;
    /**
     * The phone id
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportTagRecord
     */
    phoneId?: string;
    /**
     * The email send id
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportTagRecord
     */
    emailSendId?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof SupportTagRecord
     */
    created?: string;
    /**
     * The user id of who created the resource
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportTagRecord
     */
    createdBy?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof SupportTagRecord
     */
    disabled?: string;
    /**
     * The user id of who disabled the resource
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportTagRecord
     */
    disabledBy?: string;
    /**
     * Tag id associated with the tag record
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportTagRecord
     */
    tagId?: string;
    /**
     * Tag name
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportTagRecord
     */
    tagName?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportTagRecord
     */
    eligibilityId?: string;
}

export function SupportTagRecordFromJSON(json: any): SupportTagRecord {
    return {
            'id': !exists(json, 'id') ? undefined : json['id'],
            'chargemasterId': !exists(json, 'chargemasterId') ? undefined : json['chargemasterId'],
            'claimId': !exists(json, 'claimId') ? undefined : json['claimId'],
            'paymentId': !exists(json, 'paymentId') ? undefined : json['paymentId'],
            'transmissionId': !exists(json, 'transmissionId') ? undefined : json['transmissionId'],
            'clearinghouseId': !exists(json, 'clearinghouseId') ? undefined : json['clearinghouseId'],
            'providerId': !exists(json, 'providerId') ? undefined : json['providerId'],
            'payerId': !exists(json, 'payerId') ? undefined : json['payerId'],
            'subscriberId': !exists(json, 'subscriberId') ? undefined : json['subscriberId'],
            'patientId': !exists(json, 'patientId') ? undefined : json['patientId'],
            'facilityId': !exists(json, 'facilityId') ? undefined : json['facilityId'],
            'professionalId': !exists(json, 'professionalId') ? undefined : json['professionalId'],
            'institutionalId': !exists(json, 'institutionalId') ? undefined : json['institutionalId'],
            'dentalId': !exists(json, 'dentalId') ? undefined : json['dentalId'],
            'nynf3Id': !exists(json, 'nynf3Id') ? undefined : json['nynf3Id'],
            'professionalTemplateId': !exists(json, 'professionalTemplateId') ? undefined : json['professionalTemplateId'],
            'institutionalTemplateId': !exists(json, 'institutionalTemplateId') ? undefined : json['institutionalTemplateId'],
            'dentalTemplateId': !exists(json, 'dentalTemplateId') ? undefined : json['dentalTemplateId'],
            'nynf3TemplateId': !exists(json, 'nynf3TemplateId') ? undefined : json['nynf3TemplateId'],
            'documentId': !exists(json, 'documentId') ? undefined : json['documentId'],
            'mailId': !exists(json, 'mailId') ? undefined : json['mailId'],
            'letterId': !exists(json, 'letterId') ? undefined : json['letterId'],
            'faxSendId': !exists(json, 'faxSendId') ? undefined : json['faxSendId'],
            'faxReceiveId': !exists(json, 'faxReceiveId') ? undefined : json['faxReceiveId'],
            'guarantorId': !exists(json, 'guarantorId') ? undefined : json['guarantorId'],
            'messageId': !exists(json, 'messageId') ? undefined : json['messageId'],
            'sellerId': !exists(json, 'sellerId') ? undefined : json['sellerId'],
            'clearinghouseEraId': !exists(json, 'clearinghouseEraId') ? undefined : json['clearinghouseEraId'],
            'clearinghouseEraItemId': !exists(json, 'clearinghouseEraItemId') ? undefined : json['clearinghouseEraItemId'],
            'codingId': !exists(json, 'codingId') ? undefined : json['codingId'],
            'phoneId': !exists(json, 'phoneId') ? undefined : json['phoneId'],
            'emailSendId': !exists(json, 'emailSendId') ? undefined : json['emailSendId'],
            'created': !exists(json, 'created') ? undefined : json['created'],
            'createdBy': !exists(json, 'createdBy') ? undefined : json['createdBy'],
            'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
            'disabledBy': !exists(json, 'disabledBy') ? undefined : json['disabledBy'],
            'tagId': !exists(json, 'tagId') ? undefined : json['tagId'],
            'tagName': !exists(json, 'tagName') ? undefined : json['tagName'],
            'eligibilityId': !exists(json, 'eligibilityId') ? undefined : json['eligibilityId'],
    };

}

export function SupportTagRecordToForm(value?: SupportTagRecord): any {
    let jsonVal = SupportTagRecordToJSON(value);
    let retVal = '';
    if(jsonVal !== undefined && jsonVal != null) {
        Object.keys(jsonVal).forEach((v, i) => {
            if(i > 0) retVal+= "&";
            retVal+= encodeURIComponent(v) + "=" + encodeURIComponent(jsonVal[v]);
        });
    }
    return retVal;
}

function cleanupBlankValuesForBackend(val?:any): any {
    if(val instanceof Array) {
        return (val as Array<any>).filter((val) => { return val !== undefined && val !== null && val !== ''});
    } else {
        return (val === '') ? null : val;
    }
}

export function SupportTagRecordToJSON(value?: SupportTagRecord): any {
    value = cleanupBlankValuesForBackend(value);
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
            'id': cleanupBlankValuesForBackend(value.id),
            'chargemasterId': cleanupBlankValuesForBackend(value.chargemasterId),
            'claimId': cleanupBlankValuesForBackend(value.claimId),
            'paymentId': cleanupBlankValuesForBackend(value.paymentId),
            'transmissionId': cleanupBlankValuesForBackend(value.transmissionId),
            'clearinghouseId': cleanupBlankValuesForBackend(value.clearinghouseId),
            'providerId': cleanupBlankValuesForBackend(value.providerId),
            'payerId': cleanupBlankValuesForBackend(value.payerId),
            'subscriberId': cleanupBlankValuesForBackend(value.subscriberId),
            'patientId': cleanupBlankValuesForBackend(value.patientId),
            'facilityId': cleanupBlankValuesForBackend(value.facilityId),
            'professionalId': cleanupBlankValuesForBackend(value.professionalId),
            'institutionalId': cleanupBlankValuesForBackend(value.institutionalId),
            'dentalId': cleanupBlankValuesForBackend(value.dentalId),
            'nynf3Id': cleanupBlankValuesForBackend(value.nynf3Id),
            'professionalTemplateId': cleanupBlankValuesForBackend(value.professionalTemplateId),
            'institutionalTemplateId': cleanupBlankValuesForBackend(value.institutionalTemplateId),
            'dentalTemplateId': cleanupBlankValuesForBackend(value.dentalTemplateId),
            'nynf3TemplateId': cleanupBlankValuesForBackend(value.nynf3TemplateId),
            'documentId': cleanupBlankValuesForBackend(value.documentId),
            'mailId': cleanupBlankValuesForBackend(value.mailId),
            'letterId': cleanupBlankValuesForBackend(value.letterId),
            'faxSendId': cleanupBlankValuesForBackend(value.faxSendId),
            'faxReceiveId': cleanupBlankValuesForBackend(value.faxReceiveId),
            'guarantorId': cleanupBlankValuesForBackend(value.guarantorId),
            'messageId': cleanupBlankValuesForBackend(value.messageId),
            'sellerId': cleanupBlankValuesForBackend(value.sellerId),
            'clearinghouseEraId': cleanupBlankValuesForBackend(value.clearinghouseEraId),
            'clearinghouseEraItemId': cleanupBlankValuesForBackend(value.clearinghouseEraItemId),
            'codingId': cleanupBlankValuesForBackend(value.codingId),
            'phoneId': cleanupBlankValuesForBackend(value.phoneId),
            'emailSendId': cleanupBlankValuesForBackend(value.emailSendId),
            'created': cleanupBlankValuesForBackend(value.created),
            'createdBy': cleanupBlankValuesForBackend(value.createdBy),
            'disabled': cleanupBlankValuesForBackend(value.disabled),
            'disabledBy': cleanupBlankValuesForBackend(value.disabledBy),
            'tagId': cleanupBlankValuesForBackend(value.tagId),
            'tagName': cleanupBlankValuesForBackend(value.tagName),
            'eligibilityId': cleanupBlankValuesForBackend(value.eligibilityId),
    };
}


